import { render, staticRenderFns } from "./FormImageUpload.vue?vue&type=template&id=708b7060"
import script from "./FormImageUpload.vue?vue&type=script&lang=ts"
export * from "./FormImageUpload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('708b7060')) {
      api.createRecord('708b7060', component.options)
    } else {
      api.reload('708b7060', component.options)
    }
    module.hot.accept("./FormImageUpload.vue?vue&type=template&id=708b7060", function () {
      api.rerender('708b7060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tailwindui/form/FormImageUpload.vue"
export default component.exports